module.exports = __webpack_public_path__ + "img/2019-07-22.a245f26b.jpg";